import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const AppButton = ({ className, href }) => (
  <a
    className={cx('component', className)}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  />
);

AppButton.propTypes = {
  className: PropTypes.any,
  href: PropTypes.string,
};

export default AppButton;
